<div class="nav-list">
  <a class="nav-list__item" *ngFor="let link of menuLinks" [routerLink]="link.url" routerLinkActive="active" (click)="onLinkClick()">
    <mat-icon class="mr-1" *ngIf="link.icon">{{ link.icon }}</mat-icon>
    <div class="nav-list__item__title">{{ link.label }}</div>
  </a>
</div>
